import { useTheme } from "@hooks";

export const PersonFilled = () => {
  const { theme } = useTheme();

  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 16.1787C15.625 16.1787 14.5 15.7504 13.625 14.8937C12.75 14.037 12.3125 12.9356 12.3125 11.5894C12.3125 10.2432 12.75 9.14171 13.625 8.28502C14.5 7.42834 15.625 7 17 7C18.375 7 19.5 7.42834 20.375 8.28502C21.25 9.14171 21.6875 10.2432 21.6875 11.5894C21.6875 12.9356 21.25 14.037 20.375 14.8937C19.5 15.7504 18.375 16.1787 17 16.1787ZM7 26V23.124C7 22.3489 7.19792 21.686 7.59375 21.1353C7.98958 20.5845 8.5 20.1664 9.125 19.8808C10.5208 19.2689 11.8594 18.81 13.1406 18.504C14.4219 18.1981 15.7083 18.0451 17 18.0451C18.2917 18.0451 19.5729 18.2032 20.8438 18.5193C22.1146 18.8355 23.4479 19.2893 24.8438 19.8808C25.4896 20.1664 26.0104 20.5845 26.4062 21.1353C26.8021 21.686 27 22.3489 27 23.124V26H7Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
